<template>
  <div v-if="isLoaded" :class="{'hide-tweets': hideTweets}">
    <div v-if="requiresAuthorization">
      <sign-in-to-twitter></sign-in-to-twitter>
    </div>
    <div v-else>
      <v-container fluid class="content-container">
        <v-layout row wrap>
          <v-flex md12>
            <div class="heading then-cardlist heading-top">Your Tweets</div>
            <div v-if="tweets && tweets.length">
              <editable-tweet
                :tweet="tweet"
                v-for="tweet in tweets"
                :key="tweet.id"
                @tweetAdded="refreshTweets"
              ></editable-tweet>
            </div>
            <div v-else>
              <no-content :half="true" icon="timeline" v-if="enableTwitter">Add your first tweet below to get promoted!</no-content>
              <no-content :half="true" v-else>Due to the rapidly changing environment at Twitter,
                <br />we have disabled this feature.
                <br />
                <br />Thank you for your understanding!
              </no-content>
                <br />
                <br />
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid class="content-container" v-if="enableTwitter">
        <v-layout row wrap>
          <v-flex md12>
            <div class="heading then-cardlist heading-top">Add Tweet</div>
            <add-tweet @tweetAdded="refreshTweets"></add-tweet>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import AddTweet from "@/components/Social/AddTweet";
import EditableTweet from "@/components/Social/EditableTweet";
import SignInToTwitter from "@/components/Social/SignInToTwitter";
import NoContent from "@/components/Page/NoContent";
import Back from "../modules/Back";
import Cookies from "js-cookie";
import { mapState } from "vuex";

export default {
  name: "YourTweetsPage",
  components: { AddTweet, EditableTweet, SignInToTwitter, NoContent },
  data: function() {
    return {
      tweets: [],
      hideTweets: true
    };
  },
  computed: {
    isLoaded: function() {
      return this.user;
    },
    requiresAuthorization: function() {
      const value = !(this.user && this.user.is_tw_authorized);

      return value;
    },
    enableTwitter() {
      return process.env.VUE_APP_TWITTER_DISABLE!=="true";
    },
    ...mapState({
      user: "user"
    })
  },
  async created() {
    console.log("query", this.$route.query);

    const authOutcome = this.$route.query.outcome;

    if (authOutcome === "1") {
      const cookiePath = Cookies.get("tw-return");
      if (cookiePath) {
        this.$toasted.show(
          "Great! You're now signed in with Twitter on Pubby!",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 3000
          }
        );
        this.$router.push(cookiePath);
        return;
      }
    }
    if (authOutcome === "0") {
      this.$toasted.show(
        "Oops! Something went wrong. Please try again later.",
        {
          icon: "error",
          position: "bottom-center",
          duration: 2000
        }
      );
    }

    this.tweets = await Back.tweets();
    console.log("tweets", this.tweets);
  },
  mounted() {
    var that = this;
    setTimeout(function() {
      twttr.widgets.load();
    }, 600);
    setTimeout(function() {
      that.hideTweets = false;
    }, 1000);
  },
  methods: {
    refreshTweets: async function() {
      console.log("refreshTweets");
      this.tweets = await Back.tweets();

      setTimeout(function() {
        twttr.widgets.load();
      }, 500);
    }
  }
};
</script>

<style scoped>
</style>
